import clsx from 'clsx';
import { SearchIcon } from '@music-vine/cadence/icons';
import { AnimatePresence, motion } from 'motion/react';
import { Button } from '@music-vine/cadence/ui';
import useTWScreens from '@/hooks/ui/useTWScreens';
import { cn } from '@/lib/utils';
interface InputButtonsProps {
  keyword?: string;
  onClear: () => void;
}
const ClearButton = ({
  onClick
}: {
  onClick: () => void;
}) => <Button className="h-auto rounded-full p-1.5 hover:bg-transparent focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-gray-600 dark:focus-visible:ring-white" onClick={onClick} size="sm" variant="transparent" data-sentry-element="Button" data-sentry-component="ClearButton" data-sentry-source-file="InputButtons.tsx">
    <span className="sr-only">Clear search input</span>
    <svg className="text-gray-700 dark:text-gray-200" fill="none" height="10" viewBox="0 0 10 10" width="10" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="InputButtons.tsx">
      <title>Clear search input</title>
      <path d="M0.816505 0.816461C0.561165 1.07174 0.561165 1.48566 0.816505 1.74094L4.07567 5.00016L0.819569 8.25625C0.564229 8.51154 0.564229 8.92539 0.819569 9.18067C1.07465 9.43595 1.48856 9.43595 1.7439 9.18067L5 5.92451L8.25891 9.18354C8.51425 9.43882 8.92815 9.43882 9.18349 9.18354C9.43884 8.92826 9.43884 8.51434 9.18349 8.25906L5.92459 4.99997L9.18069 1.74368C9.43603 1.4884 9.43603 1.07455 9.18069 0.81927C8.92535 0.563989 8.51169 0.563989 8.25635 0.81927L5 4.07556L1.74109 0.816461C1.48575 0.56118 1.07185 0.56118 0.816505 0.816461Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="InputButtons.tsx" />
    </svg>
  </Button>;
export const InputButtons = ({
  keyword,
  onClear
}: InputButtonsProps) => {
  const {
    isMd
  } = useTWScreens();
  const hasKeyword = Boolean(keyword?.trim());

  // Simple mobile version without animations - only search icon
  if (!isMd) {
    return <button className="flex items-center justify-center rounded-full p-1.5 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-gray-600 dark:focus-visible:ring-white" type="submit">
        <svg className="text-gray-950 dark:text-white" fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
          <title>Search</title>
          <path d="M17.5 17.5001L13.8833 13.8835M15.8334 9.16667C15.8334 12.8486 12.8486 15.8333 9.16674 15.8333C5.48484 15.8333 2.50007 12.8486 2.50007 9.16667C2.50007 5.48477 5.48484 2.5 9.16674 2.5C12.8486 2.5 15.8334 5.48477 15.8334 9.16667Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
        </svg>
      </button>;
  }

  // Desktop version with animations
  return <div className="order-2 flex items-center gap-2" data-sentry-component="InputButtons" data-sentry-source-file="InputButtons.tsx">
      <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-source-file="InputButtons.tsx">
        {hasKeyword && <motion.div animate={{
        opacity: 1,
        rotate: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        rotate: 90,
        scale: 0.8
      }} initial={{
        opacity: 0,
        rotate: 90,
        scale: 0.8
      }} transition={{
        duration: 0.15
      }}>
            <ClearButton onClick={onClear} />
          </motion.div>}
      </AnimatePresence>
      <motion.button className={clsx('relative flex items-center justify-center rounded-full p-1.5 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-gray-600 dark:focus-visible:ring-white', hasKeyword && 'hover:cursor-pointer')} type="submit" data-sentry-element="motion.button" data-sentry-source-file="InputButtons.tsx">
        <motion.div animate={{
        scale: hasKeyword ? 1 : 0,
        opacity: hasKeyword ? 1 : 0
      }} className="absolute inset-0 rounded-full bg-pink-500" initial={{
        scale: 0,
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} data-sentry-element="motion.div" data-sentry-source-file="InputButtons.tsx" />
        <SearchIcon className={cn('relative z-10 h-4! w-4! rotate-90 stroke-[4] transition-all duration-200 md:h-3 md:w-3 md:rotate-0', hasKeyword ? 'stroke-[2.5] text-white' : 'stroke-[2.5] text-gray-950 md:text-gray-700 dark:text-gray-200')} data-sentry-element="SearchIcon" data-sentry-source-file="InputButtons.tsx" />
      </motion.button>
    </div>;
};